import { createBrowserHistory } from 'history';

const appHistory = createBrowserHistory({
  basename: 'index.html',
  getUserConfirmation: (message, callback) => callback(window.confirm(message))
});

export default appHistory;
